<template>
  <section class="products">
    <h1 class="title">{{ $t('products.key001') }}</h1>
  </section>
  <Loading v-show="loading"></Loading>
</template>

<script>
import Loading from '@/components/Loading.vue';

export default {
  name: 'GiftItem',
  components: {
    Loading,
  },
  props: {},
  setup() {
    return {};
  },
  data() {
    return {};
  },
  async mounted() {},
  methods: {},
};
</script>

<style lang="scss"></style>
